import React from 'react';
import { Stack, Box, LayoutProps, ChakraProps } from '@chakra-ui/react';

interface TwoColumnsProps {
  col1: React.ReactNode;
  col2: React.ReactNode;
  reverseOrderInMobile?: boolean;
  minH?: LayoutProps['minH'];
  maxColWidth?: LayoutProps['maxW'];
  sx?: ChakraProps['sx'];
}

const TwoColumns = ({
  col1,
  col2,
  reverseOrderInMobile,
  minH = '',
  maxColWidth = '500px',
  sx = undefined,
}: TwoColumnsProps) => {
  const flexDirection = reverseOrderInMobile ? 'column-reverse' : 'column';

  return (
    <Stack
      sx={sx}
      direction={[flexDirection, flexDirection, flexDirection, 'row']}
      spacing={['16']}
      w="100%"
      minH={minH}
      h="fit-content"
      px={['4', '16']}
      pb={['6']}
      mb={['5', '24']}
      alignItems="center"
      justifyContent="center"
      textAlign="left"
    >
      <Box width="100%" maxW={maxColWidth}>
        {col1}
      </Box>
      <Box width="100%" maxW={maxColWidth}>
        {col2}
      </Box>
    </Stack>
  );
};

TwoColumns.defaultProps = {
  reverseOrderInMobile: false,
  minH: undefined,
  sx: undefined,
  maxColWidth: '500px',
};

export default TwoColumns;
